export default __webpack_public_path__ + "static/media/logo_sticky.51c17140.png";